import React, { useState } from "react";

const Tabs = ({tabs, activeTab, setActiveTab,class_='' }) => {
  return (
    <div className={`tabs-container ${class_}`}>
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`tab-button ${activeTab === tab ? "active" : ""}`}
          onClick={() => setActiveTab(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
